import { render } from "./PbsGroupDetail.vue?vue&type=template&id=eeb01562&scoped=true&ts=true"
import script from "./PbsGroupDetail.vue?vue&type=script&lang=ts"
export * from "./PbsGroupDetail.vue?vue&type=script&lang=ts"

import "./PbsGroupDetail.vue?vue&type=style&index=0&id=eeb01562&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb01562"]])

export default __exports__